import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class AnteilWaermeerzeugerWarmwasser extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    kombination: number | null = null;
    nutzungsart_id: number | null = null;
    waermeerzeuger_warmwasser_1_id: number | null = null;
    anteil_waermeerzeuger_warmwasser_1: number | null = null;
    waermeerzeuger_warmwasser_2_id: number | null = null;
    anteil_waermeerzeuger_warmwasser_2: number | null = null;
    bemerkung: string | null = null;

    // view fields
    nutzungsart: string | null = null;
    nutzungsart_reihenfolge: number | null = null;
    waermeerzeuger_warmwasser_1: string | null = null;
    waermeerzeuger_warmwasser_2: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'AnteilWaermeerzeugerWarmwasser';
    }
}

export async function createNewAnteilWaermeerzeugerWarmwasser(): Promise<AnteilWaermeerzeugerWarmwasser> {
    const model = createModel(AnteilWaermeerzeugerWarmwasser, {});

    await model.save();
    return model;
}

export class AnteilWaermeerzeugerWarmwasserCollection extends BaseCollection<AnteilWaermeerzeugerWarmwasser> {
    protected modelCls = AnteilWaermeerzeugerWarmwasser;

    public getModelClassName(): string {
        return 'AnteilWaermeerzeugerWarmwasser';
    }
}
